import { PickerMenuOption } from '../../../shared/picker/PickerMenuOption';
import { PickerMenuDivider, PickerMenuShell } from '../../../shared/picker/PickerMenuShell';
import { FRUSTRATION_META, RATED_FRUSTRATION_OPTIONS, type FrustrationOption } from './frustration';
import { FrustrationGlyph } from './FrustrationGlyph';

interface FrustrationMenuProps {
    current: FrustrationOption;
    onSelect: (option: FrustrationOption) => void;
    // Off where the API can't clear a rating, so "Not set" isn't a dead pick.
    allowUnset?: boolean;
}

function FrustrationOptionRow({
    option,
    current,
    onSelect
}: Pick<FrustrationMenuProps, 'current' | 'onSelect'> & { option: FrustrationOption }) {
    const meta = FRUSTRATION_META[option];
    return (
        <PickerMenuOption
            glyph={<FrustrationGlyph lit={meta.litBars} className={meta.menuGlyphTone} />}
            label={meta.label}
            description={meta.description}
            labelClassName={meta.menuLabelTone}
            selected={option === current}
            onPick={() => onSelect(option)}
        />
    );
}

export function FrustrationMenu({ current, onSelect, allowUnset = true }: FrustrationMenuProps) {
    return (
        <PickerMenuShell heading="Frustration">
            {RATED_FRUSTRATION_OPTIONS.map((option) => (
                <FrustrationOptionRow
                    key={option}
                    option={option}
                    current={current}
                    onSelect={onSelect}
                />
            ))}
            {allowUnset && (
                <>
                    <PickerMenuDivider />
                    <FrustrationOptionRow option="unset" current={current} onSelect={onSelect} />
                </>
            )}
        </PickerMenuShell>
    );
}
